import { Navigation } from '@/components/layout/Navigation';
import { AnimatedOutlet } from '@/components/layout/AnimatedOutlet';
import { HermesChatbot } from '@/components/ui/HermesChatbot';

export function RootLayout() {
  return (
    <div className="min-h-screen bg-surface-900">
      {/* Skip link for keyboard/screen reader users (WCAG 2.4.1) */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-primary-700 focus:text-white focus:rounded focus:outline-none focus:ring-2 focus:ring-primary-400"
      >
        Skip to main content
      </a>
      <Navigation />
      <main id="main-content" tabIndex={-1}>
        <AnimatedOutlet />
      </main>
      {/* Hermes AI Assistant - floating chat button */}
      <HermesChatbot />
    </div>
  );
}
